import React, { Component } from 'react';
import { Modal, Button } from 'reactstrap';

import SVGIcon from './icon'

import './status_modal.css'

const customStyles = {
  overlay: {
    zIndex: 1301 // because material ui dialog is having 1300 as z index
  },
  content : {
    top                   : '40%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    paddingRight          : '40px'
  }
};

class StatusModal extends Component {
  state = {
    isOpen: false,
    isPaused: false
  }

  componentDidUpdate = pp => {
    if( this.props.isOpen !== pp.isOpen ) {
      this.setState({ isOpen: this.props.isOpen })
    }
  }

  renderModalContent = () => {
    const { message, type } = this.props;
    return (
      <div style={{ padding: 15 }}>
        <div className="d-flex">
          <SVGIcon 
            style={{ 
              fill: type === 'positive' ? '#5eb85b': '#d01c28', 
              width: 30, height: 30, marginRight: 20 
            }}
            svgHref={ type === 'positive' ? 'icon-tick' : "icon-exclamation" }/>
          <div dangerouslySetInnerHTML={{ __html: message }}/>
        </div>
        <div className="d-flex justify-content-end mt-2">
          <Button
            size={ "sm"}
            color="primary"
            onClick={() => this.props.onClick() }>
            Close
          </Button>
        </div>
      </div>
    )
  }

  render = () => {
    return (
      <Modal  
        centered={ true }
        size={ 'md' }
        className={ 'esign-modal' }
        isOpen={ this.state.isOpen }
        toggle={ () => this.props.onClick() }
        style={ customStyles }>
        { this.renderModalContent() }
      </Modal>
    )
  }
}

export default StatusModal;